import React, {useEffect, useRef, useState} from 'react'
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import {Controller, useForm} from "react-hook-form"
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import PrintIcon from '@mui/icons-material/Print';
import TaskIcon from '@mui/icons-material/Task';
import Select from 'react-select'
import classes from './form.module.scss'
import {toast} from 'react-toastify';
import PushElements from "../../../../PushElements";
import {DirectionService} from "../../../../../api/directionService";
import errorMessage from "../../../../../const/Tost";
import TablePrint from '../../../../TablePrint'
import {useNavigate} from "react-router-dom";
import {log} from "qrcode/lib/core/galois-field";
import QrCodeOutlinedIcon from '@mui/icons-material/QrCodeOutlined';
import QRCode from '../../../../common/QrCodeGenerator';

const Form = ({values, patientNumber, pasteHandler, isCopied, outside, departments}) => {
    // variables starts
    const {
        register,
        handleSubmit,
        trigger,
        watch,
        formState: {errors},
        setValue,
        resetField,
        control,
        getValues
    } = useForm();

    const navigate = useNavigate();
    const iframeRef = useRef(null);
    const info = useSelector(state=>state.RegScan.ScanInputs)

    const [modal, setModal] = useState(false)
    const [inputs, setInputs] = useState({"title": '', "id": ''})
    const [filteredData, setFilteredData] = useState([])
    const [removedFormList, setRemovedFromList] = useState(['antibodies'])
    const [patientId, setPatientId] = useState(0)
    const [directionId, setDirectionId] = useState(0)
    const [isCreated, setIsCrated] = useState(false)
    const [readOnlyValue, setReadOnlyValue] = useState(false)
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [searchedDoctors, setSearchedDoctors] = useState([])
    const [availableContracts, setAvailableContracts] = useState([])
    const [dataForResearch, setDataForResearch] = useState(null)
    const [contractIdState, setContractId] = useState(null)
    const [registrationType, setRegistrationType] = useState(null)
    const [labels,setLabels] = useState()
    const [print, setPrint] = useState(false)
    
    const CodePrint = () =>{
        let arr = []
        for(let i = 0; i < numberCode - 1; i++){
            arr.push({
                "labels": info
            })
        }

        setLabels(arr)
        setPrint(true)
    }
    const closePrint = () => {
        setPrint(false)
    }

    const allData = getValues();
    let numberCode = (+(watch("quantityMaterial")) + 1)

    const research = watch('research');
    const year = watch("ageYears");
    const month = watch("ageMonths");
    const hospital = watch("hospitalId");
    const activeContract = watch("activeContract");
    const contractId = watch("contractId");

    const onSubmit = async(data) => {
        if (!data?.biopsy){
            errorMessage('', 'Оберіть тип біопсії');
        } else if (data?.ageYears === '0' && !data?.ageMonths && !data?.ageDays || data?.ageMonths === '0' && !data?.ageDays){
            errorMessage('', 'Вкажіть правильний вік');
        } else {
            const gender = data.gender ? data?.gender : values?.fields?.filter(el => el?.name == "gender");
            const additionalData = registrationType === 'BASIC' ? {departmentId: data.departmentId} : {externalDepartmentId: data.departmentId}
            if (registrationType === 'COMPLETED') delete data['departmentId']

            const patientInfo = {
                ...data,
                status: 'registered', gender: data.gender ? data.gender : gender[0]?.value,
                ageYears: data?.ageYears && data.ageYears !== '0' ? data.ageYears : null,
                ageMonths: data?.ageMonths && data.ageMonths !== '0' ? data.ageMonths : null,
                ageDays: data?.ageDays && data.ageDays !== '0' ? data.ageDays : null, outside,
                contractId: activeContract && !!contractIdState ? contractIdState : null,
            }

            await DirectionService.createDirection({...patientInfo, ...additionalData, patientId}).then(res => {
                if (res?.data){
                    setPatientId(res?.data?.patientId)
                    setDirectionId(res?.data?.id)
                    setIsCrated(true)
                    setReadOnlyValue(true)
                    toast.success('Скерування сформовано')
                }
            })
        }
    }

    const addFieldHandler = (title, id) => {
        setModal(true)
        setInputs({
            "title": title,
            "id": id
        })
    }

    const onClose = () => {
        resetField('hospitalId');
        resetField('departmentId');
        resetField('research');
        resetField('antibodies');
        setAvailableContracts([])
        setModal(false)
    }

    const copyHandler = () => {
        const data = getValues();

        delete data['biopsy']
        delete data['ageMonths']
        delete data['ageYears']
        delete data['ageDays']
        delete data['research']
        delete data['hospitalId']
        delete data['departmentId']
        delete data['operationName']
        delete data['operationDate']
        delete data['quantityMaterial']
        delete data['operationDate']
        delete data['activeDoc']

        if (!data?.gender){
            const gender = data.gender ? data?.gender : values?.fields?.filter(el => el?.name == "gender")[0]?.value;

            localStorage.setItem('PatientData', JSON.stringify({...data, gender, id: patientId}))
        } else {
            localStorage.setItem('PatientData', JSON.stringify({...data, id: patientId}))
        }
        toast.info('Дані скопійовано')
    }

    const printHandler = async() => {
        if (directionId){
            await DirectionService.getDirectionHTML(directionId).then(res => {
                if (res?.data){
                    const iframe = iframeRef.current;
                    const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

                    iframeDoc.open();
                    iframeDoc.write(res?.data);
                    iframeDoc.close();

                    iframe.onload = () => {
                        iframe.contentWindow.print();
                    };
                }
            })
        }
    }

    const removeLeadingZeros = (value) => {
        if (value && value.length > 1){
            return value.replace(/^0+/, '');
        }
        return value;
    };

    const findByParamsHandler = async(e) => {
        await DirectionService.getDirectionDataByParam(e).then(res => {
            if (res?.data){
                setSearchedDoctors(res?.data)
            }
        })
    }

    // dynamic fields of age start
    useEffect(() => {
        const monthInput = document.querySelector('[name="ageMonths"]');
        const dayInput = document.querySelector('[name="ageDays"]');

        if (year == '0'){
            monthInput.disabled = false;
            dayInput.disabled = true;
        } else if (year > 0 || year == ''){
            setValue("ageMonths", '');
            setValue("ageDays", '');
            monthInput.disabled = true;
            dayInput.disabled = true;
        }

        setValue("ageYears", removeLeadingZeros(year));
    }, [year, setValue]);


    useEffect(() => {
        const dayInput = document.querySelector('[name="ageDays"]');

        if (month == '0'){
            dayInput.disabled = false;
        } else if (month > 0 || month == ''){
            setValue("ageDays", '');   // Сброс значения дня
            dayInput.disabled = true;
        }

        setValue("ageMonths", removeLeadingZeros(month));
    }, [month, setValue]);

    const patientCredits = values?.fields?.map(el => ['lastName', 'middleName', 'name'].includes(el?.name) && el?.value ? el?.value : '').join(' ').trim()

    // dynamic fields of age ends
    useEffect(() => {
        if (isCopied){
            values.fields.forEach((el) => {
                setValue(el.name, el.value);
            });
        }

        if (values?.fields?.length){
            const array = values?.fields?.filter((el) => !removedFormList.includes(el.name))
            setFilteredData(array)
        }
    }, [values]);

    useEffect(() => {
        if (!removedFormList.includes('antibodies')){
            const getData = async() => {
                const response = await DirectionService.getOptions();
                setFilteredData((prev) => {
                    const updatedData = [
                        ...prev,
                        {
                            dataType: "antibodies",
                            id: 22,
                            legend: "Антитіла",
                            name: "antibodies",
                            options: true,
                            required: true,
                            type: "text",
                            props: response?.data?.antibodies.map(el => ({
                                value: el.name,
                                label: el.name,
                                id: el.id,
                                type: 'option'
                            })),
                        },
                    ];

                    return updatedData.sort((a, b) => a.id - b.id);
                });
            };

            getData();
        } else {
            const array = values?.fields?.filter((el) => !removedFormList.includes(el.name))
            setFilteredData(array)
        }
    }, [removedFormList]);

    useEffect(() => {
        setRemovedFromList((prev) => {
            if (research === 'ІГХ'){
                return prev.filter((item) => item !== 'antibodies');
            } else if (!prev.includes('antibodies')){
                return [...prev, 'antibodies'];
            }
            return prev;
        });

        if (outside){
            setRemovedFromList((prev) => {
                if (!prev.includes('phoneNumber')){
                    return [...prev, 'phoneNumber'];
                }
                return prev;
            });
        }
    }, [research, outside]);

    useEffect(() => {
        setPatientId(patientNumber)
    }, [patientNumber]);

    const validateClinic = (params, p) => {
        return params?.available > 0
            ? {...p, isDisabledCheck: false, available: params.available}
            : {...p, isDisabledCheck: true, available: 0};
    };

    useEffect(() => {
        const hospitals = values?.fields?.find(el => el?.name === 'hospitalId');
        const chosenHospital = hospitals?.props?.find(e => e.id === allData.hospitalId)?.departments?.map(dep => ({
            id: dep.id,
            label: dep.name,
            value: dep.name,
            registrationType: dep.registrationType,
            type: 'option',
        })) || [];

        if (allData.hospitalId){
            const getAvailableContrants = async() => {
                await DirectionService.getContractForClinic(+allData.hospitalId).then(res => {
                    if (!!res?.data?.data?.length){
                        setAvailableContracts(res?.data?.data)

                        setFilteredData(prev =>
                            prev.map(item =>
                                item.name === 'contractId'
                                    ? {
                                        ...item,
                                        props: res?.data?.data?.map(el => ({
                                            label: el.name,
                                            value: el.id,
                                        })),
                                    }
                                    : item
                            )
                        );

                    }
                })
            }
            getAvailableContrants()

            resetField('departmentId');
            resetField('research');
            resetField('contractId');
            setFilteredData(prev =>
                prev.map(item =>
                    item.name === 'contractId'
                        ? {
                            ...item,
                            props: [],
                        }
                        : item
                )
            );
            setAvailableContracts([])

            setFilteredData(prev =>
                prev.map(item =>
                    item.name === 'departmentId'
                        ? {...item, props: chosenHospital.length ? chosenHospital : departments}
                        : item,
                )
            );
        }
    }, [hospital]);

    useEffect(() => {
        if (!!contractId && contractId !== 'Оберіть контракт'){
            const getAvailableContrants = async() => {
                await DirectionService.getContractDataByClinic(+allData.hospitalId, contractId).then(res => {
                    if (res?.data === null){
                        setContractId(null)
                        setDataForResearch(null)
                        setFilteredData(prev =>
                            prev.map(item =>
                                item.name === "research"
                                    ? {
                                        ...item,
                                        isDisabledOpt: false,
                                        props: item.props.map(p => ({...p, isDisabledCheck: true, available: 0}))
                                    }
                                    : item
                            )
                        );
                    }

                    if (res?.data){
                        const {CISH, ІГХ, Гістологія, Експрес} = res?.data.agreements;
                        setDataForResearch({CISH, ІГХ, Гістологія, Експрес})
                        setContractId(res?.data.id)
                        setFilteredData(prev =>
                            prev.map(item =>
                                item.name === "research"
                                    ? {
                                        ...item,
                                        isDisabledOpt: false,
                                        props: item.props.map(p => {
                                            switch(p.label){
                                                case "Гістологія":
                                                    return validateClinic(Гістологія, p);
                                                case "ІГХ":
                                                    return validateClinic(ІГХ, p);
                                                case "CISH":
                                                    return validateClinic(CISH, p);
                                                case "Експрес":
                                                    return validateClinic(Експрес, p);
                                                default:
                                                    return p;
                                            }
                                        })
                                    }
                                    : item
                            )
                        );
                    }
                })
            }
            getAvailableContrants()

        }
    }, [contractId]);

    useEffect(() => {
        if (!!dataForResearch && dataForResearch[research]?.available){
            if (research === 'Гістологія'){
                const item = dataForResearch[research];

                toast.success(
                    <div>
                        <div>Дослідження «{research}» :</div>
                        {Object.entries(item.complexity).map(([level, obj]) => (
                            <div key={level}>
                                • Складність {level}: {obj.available > 0 ? obj.available : 'недоступна'}
                            </div>
                        ))}
                    </div>
                );
            } else {
                toast.success(`Досліджень залишилося ${dataForResearch[research].available}`)
            }
        }
    }, [research]);

    return (
        <>
            <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
                {values.formType === 'registration' && <div className={classes.form__registration__iconsBox} style={{display: 'flex'}}>
                    <ContentCopyIcon style={{display: !isCreated ? 'none' : 'flex'}} onClick={() => copyHandler()} className={classes.icon}/>
                    <QrCodeOutlinedIcon style={{display: !isCreated ? 'none' : 'flex'}} onClick={() => CodePrint()} className={classes.icon}/>
                    <PrintIcon style={{display: !isCreated ? 'none' : 'flex'}} onClick={() => printHandler()} className={classes.icon}/>
                    <TaskIcon style={{display: isCreated ? 'none' : 'flex'}} onClick={() =>
                        pasteHandler()
                    } className={classes.icon}/>
                </div>
                }
                {<h2 style={{
                    maxWidth: "600px",
                    textAlign: "center"
                }}>{outside ? "Створити скерування з іншої клініки" : patientCredits ? 'Створити скерування для ' + patientCredits : 'Створити нове скерування'}</h2>}
                {filteredData?.map((el, index) => (!(el.name === 'departmentId' && !allData.hospitalId) &&
                    <div className={classes[values.class]} key={index}>
                        <legend className={classes.form__label} htmlFor={el.type}>{el.legend}</legend>
                        <div className={classNames(classes.form__label__container, {[classes.сassets__container]: el.name == 'cassets'})}>
                            {el?.value && el?.name !== 'gender' ? <>
                                <label htmlFor={el.name}>{el.label}</label>
                                <div>
                                    <input
                                        className={classNames(classes.form__input, {[classes.errorInput]: errors[el.name]})}
                                        type={el.type}
                                        readOnly={el.show}
                                        value={el.value || ''}
                                        readOnly={readOnlyValue}
                                        {...register(el.name)}
                                    />
                                </div>
                            </> : el?.value && el?.name == 'gender' ? <Select
                                    className={classes.select}
                                    options={el.props.map(option => ({
                                        value: option.value,
                                        label: option.label
                                    }))}
                                    defaultValue={el.props.find(option => option.value == el.value)}
                                    isDisabled={el.show}
                                    placeholder='Виберіть значення...'
                                    readOnly={readOnlyValue}
                                    {...register(el.name)}
                                />
                                :
                                (el.name === 'departmentId' && !allData.hospitalId) ? null :
                                    el.options
                                        ?
                                        <div>
                                            <Controller
                                                control={control}
                                                name={el.name}
                                                rules={el.name === 'contractId' ? {} : { required: "Оберіть одне значення" }}
                                                render={({field: {onChange, value}, fieldState: {error}}) => (
                                                    <Select
                                                        className={classNames(
                                                            classes.select,
                                                            {[classes.errorInput]: error}
                                                        )}
                                                        options={el.props}

                                                        value={
                                                            value === undefined
                                                                ? null
                                                                : el.name === 'antibodies'
                                                                    ? el.props.filter(option => value?.includes(option.id))
                                                                    : el.props.find(option => {
                                                                        const optionValue = ['gender', 'contractId'].includes(el.name)
                                                                            ? option.value
                                                                            : option.id;
                                                                        return optionValue === value;
                                                                    })
                                                        }
                                                        onChange={(selectedOption) => {
                                                            if (el.name === 'antibodies'){
                                                                const newValue = selectedOption.map(option => {
                                                                    return ['departmentId', 'hospitalId', 'antibodies'].includes(el.name)
                                                                        ? option.id
                                                                        : option.value;
                                                                });
                                                                onChange(newValue);
                                                            } else {
                                                                const newValue = ['departmentId', 'hospitalId'].includes(el.name)
                                                                    ? selectedOption.id
                                                                    : el.name === 'gender' || el.name === 'contractId'
                                                                        ? selectedOption.value
                                                                        : selectedOption.label;
                                                                if (el.name === 'hospitalId'){
                                                                    setRegistrationType(selectedOption.registrationType)
                                                                }
                                                                onChange(newValue);
                                                            }
                                                        }}
                                                        isMulti={el.name === 'antibodies'}
                                                        disableSearch
                                                        hasSelectAll={false}
                                                        placeholder='Оберіть значення...'
                                                        getOptionLabel={(option) => option.label}
                                                        getOptionValue={(option) =>
                                                            ['gender', 'contractId'].includes(el.name) ? option.value : option.id
                                                        }
                                                        isDisabled={readOnlyValue || (el.name === 'research' && el.isDisabledOpt && !hospital)}
                                                    />
                                                )}
                                            />

                                            {el.name !== 'contractId' && (
                                                el.name === 'antibodies' ? (
                                                    <AddCircleOutlineIcon
                                                        onClick={() => {
                                                            trigger(addFieldHandler(el.legend, el.name));
                                                        }}
                                                        className={classes.icon}
                                                    />
                                                ) : (
                                                    ((registrationType === 'COMPLETED' && el.name === 'hospitalId') ||
                                                        registrationType === 'BASIC' ||
                                                        registrationType === null) &&
                                                    el.name !== 'research' &&
                                                    !['gender', 'markedMaterial'].includes(el.name) && (
                                                        <AddCircleOutlineIcon
                                                            onClick={() => {
                                                                trigger(addFieldHandler(el.legend, el.name));
                                                            }}
                                                            className={classes.icon}
                                                        />
                                                    )
                                                )
                                            )}
                                            {el.name === 'contractId' && contractId && (
                                            <RemoveCircleOutlineIcon
                                                onClick={() => {
                                                    resetField('contractId')
                                                    setDataForResearch(null)
                                                }}
                                                className={classes.icon}
                                            />)}

                                            {errors[el.name] && el.name !== 'contractId'  && (
                                                <p className={classNames('DefaultForm-select-hint', classes.errorHint)}>
                                                    Оберіть одне значення
                                                </p>
                                            )}
                                        </div>
                                        : el?.props?.map((props, i) => (
                                            <div className={classNames(classes.form__label__container__box)} key={'a' + i}>
                                                <div><label>{props.label}</label></div>
                                                <div>
                                                    {el.name === 'activeDoc' ? (
                                                        <Controller
                                                            control={control}
                                                            name={el.name}
                                                            rules={{
                                                                required: "Поле обов'язкове для заповнення",
                                                            }}
                                                            render={({field: {onChange, value}, fieldState: {error}}) => {

                                                                const handleInputChange = (e) => {
                                                                    const inputValue = e.target.value;
                                                                    onChange(inputValue);
                                                                    if (el.name === 'activeDoc'){
                                                                        findByParamsHandler(inputValue);
                                                                        setShowSuggestions(true);
                                                                    }
                                                                };

                                                                const handleOptionClick = (option) => {
                                                                    onChange(option);
                                                                    setShowSuggestions(false);
                                                                };

                                                                return (
                                                                    <div className={classes.inputWrapper}>
                                                                        <input
                                                                            className={classNames(classes.form__input, {
                                                                                [classes.errorInput]: error,
                                                                            })}
                                                                            type="text"
                                                                            value={value || ''}
                                                                            onChange={handleInputChange}
                                                                            placeholder="Введіть значення..."
                                                                            autoComplete="off"
                                                                            readOnly={readOnlyValue}
                                                                            disabled={readOnlyValue}
                                                                            onBlur={() => setTimeout(() => setShowSuggestions(false), 200)} // дати час на клік
                                                                            onFocus={() => setShowSuggestions(true)}
                                                                        />

                                                                        {el.name === 'activeDoc' && searchedDoctors?.length > 0 && showSuggestions && (
                                                                            <ul className={classes.suggestionsList}>
                                                                                {searchedDoctors
                                                                                    .filter((option) => option !== value)
                                                                                    .map((option, idx) => (
                                                                                        <li
                                                                                            key={idx}
                                                                                            className={classes.suggestionItem}
                                                                                            onClick={() => handleOptionClick(option)}
                                                                                        >
                                                                                            {option}
                                                                                        </li>
                                                                                    ))}
                                                                            </ul>
                                                                        )}
                                                                    </div>
                                                                );
                                                            }}
                                                        />
                                                    ) : el.name == 'clinicalConclusion' || el.name == 'clinicalInfo'
                                                        ? <textarea
                                                            className={classNames(classes.form__input, {[classes.errorInput]: errors[el.name]})}
                                                            placeholder={props.placeholder}
                                                            disabled={props.show}
                                                            {...register(el.name)}
                                                            value={el.type === 'radio' ? props.label : props.value}
                                                            {...register(el.name, {required: "Поле обов'язкове для заповнення"})}
                                                            readOnly={readOnlyValue}
                                                        />
                                                        : el.name == 'quantityMaterial' ? <input
                                                            className={classNames(classes.form__input, {
                                                                [classes.errorInput]: errors[el.name],
                                                            })}
                                                            style={el.name === 'birthDate' ? {width: '50px'} : {}}
                                                            type={props.type}
                                                            min={props.min}
                                                            placeholder={props.placeholder}
                                                            pattern={props.pattern}
                                                            defaultValue={props.defaultValue}
                                                            maxLength={el.name === 'phoneNumber' && props.max}
                                                            disabled={props.show}
                                                            onInput={(e) => {
                                                                if (el.name === 'quantityMaterial'){
                                                                    const value = Number(e.target.value);
                                                                    const min = Number(props.min);
                                                                    const max = Number(props.max);
                                                                    if (value > max){
                                                                        e.target.value = max;
                                                                    } else if (value < min){
                                                                        e.target.value = min;
                                                                    }
                                                                }
                                                            }}
                                                            value={el.type === 'radio' ? props.label : props.value}
                                                            {...register(props?.name ? props?.name : el.name, {
                                                                required:
                                                                    el.type !== 'radio' &&
                                                                    el.name !== 'birthDate' &&
                                                                    "Поле обов'язкове для заповнення",
                                                                validate: el.name === 'quantityMaterial'
                                                                    ? (val) => {
                                                                        const num = Number(val);
                                                                        if (num < props.min){
                                                                            return `Значення не може бути менше ${props.min}`;
                                                                        }
                                                                        if (num > props.max){
                                                                            return `Значення не може бути більше ${props.max}`;
                                                                        }
                                                                        return true;
                                                                    }
                                                                    : undefined,
                                                            })}
                                                        /> : <input
                                                            className={classNames(classes.form__input, {[classes.errorInput]: errors[el.name]})}
                                                            style={el.name === 'birthDate' ? {width: '50px'} : {}}
                                                            type={props.type}
                                                            min={props.min}
                                                            placeholder={props.placeholder}
                                                            pattern={props.pattern}
                                                            defaultValue={props.defaultValue}
                                                            maxLength={el.name === 'phoneNumber' && props.max}
                                                            disabled={props.show}
                                                            onInput={(e) => {
                                                                if (el.name === 'birthDate'){
                                                                    const value = e.target.value;
                                                                    if (Number(value) > props.max){
                                                                        e.target.value = props.max;
                                                                    } else if (Number(value) < props.min){
                                                                        e.target.value = props.min;
                                                                    }
                                                                }
                                                            }}
                                                            value={el.type == 'radio' ? props.label : props.value}
                                                            {...register(
                                                                props?.name ? props?.name : el.name,
                                                                {
                                                                    required: (el.type !== 'radio' && el.name !== 'birthDate') && "Поле обов'язкове для заповнення"
                                                                }
                                                            )}
                                                            readOnly={readOnlyValue}
                                                            defaultChecked={readOnlyValue}
                                                            disabled={readOnlyValue}
                                                            list={el.name === 'activeDoc' ? 'docOptions' : undefined}
                                                        />}

                                                    {errors[el.name] && (
                                                        <p className={classNames('DefaultForm-input-hint', classes.errorHint)}>
                                                            Це поле є обов'язковим
                                                        </p>
                                                    )}
                                                </div>
                                            </div>
                                        ))
                            }
                        </div>
                    </div>
                ))}
                {dataForResearch && !!dataForResearch[research]?.available &&
                    <div style={{display: 'flex', justifyContent: 'space-between', width: '100%'}}>
                        <div>Додати це скерування до контракту</div>
                        <div><input type="checkbox" {...register('activeContract')}/></div>
                    </div>
                }

                <button className={classes.form__button} type='submit' style={{display: isCreated ? 'none' : 'flex'}}>
                    {values.button}
                </button>
                {isCreated && <div style={{display: 'flex', justifyContent: 'space-around', width: '100%'}}>
                    <button type={'button'} onClick={() => navigate('/Referrals')} className={classes.form__button}>
                        Закрити
                    </button>
                    <button type={'button'} onClick={() => window.location.reload()} className={classes.form__button}>
                        Створити ще одне скерування
                    </button>
                </div>}
            </form>
            <iframe ref={iframeRef} style={{display: 'none'}}/>
            {print && <TablePrint onClose={closePrint} labels={labels}/>}
            {modal && <PushElements onChange={onClose} title={inputs.title} id={inputs.id}/>}
        </>
    )
}

export default Form
